var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m913.49 494.08-384-384c-15.36-15.36-36.69-24.75-60.16-24.75H170.67c-46.93 0-85.33 38.4-85.33 85.33v298.67c0 23.47 9.39 44.8 25.17 60.59l384 384c15.36 15.36 36.69 24.75 60.16 24.75s44.8-9.39 60.16-25.17L913.5 614.83c15.79-15.36 25.17-36.69 25.17-60.16s-9.81-45.23-25.17-60.59ZM234.67 298.67c-35.41 0-64-28.59-64-64s28.59-64 64-64 64 28.59 64 64-28.59 64-64 64"
  })));
};
export default SvgTag;